// Shared presentation styles/handlers for RestaurantSearch.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (the module-level
// `primaryBlue`/`hoverBlue` colors, the `filterSelectStyle`, `filterLabelStyle`,
// and `locationButtonStyle` objects, the `locationSelectorButtonStyle(isActive)`
// helper, and the `blueHover`/`blueOut` hover handlers) as part of the
// behavior-preserving refactor (issue #240). These are the presentation-side
// pieces deliberately left out of the pure-logic extraction (task 15.2).
// Values, keys, and ordering are identical to the source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

// ── Colors ───────────────────────────────────────────────────────────────────

export const primaryBlue = '#0ea5e9';
export const hoverBlue = '#0284c7';

// ── Shared styles ─────────────────────────────────────────────────────────────

export const filterSelectStyle = {
  width: '100%',
  padding: '8px',
  border: '1px solid #d1d5db',
  borderRadius: '4px',
  fontSize: '14px'
};

export const filterLabelStyle = {
  display: 'block',
  fontSize: '13px',
  fontWeight: '500',
  marginBottom: '6px',
  color: '#374151'
};

export const locationButtonStyle = {
  padding: '16px',
  fontSize: '16px',
  fontWeight: '600',
  color: 'white',
  backgroundColor: primaryBlue,
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  transition: 'background-color 0.2s',
  textAlign: 'left'
};

export const locationSelectorButtonStyle = (isActive) => ({
  flex: 1,
  padding: '12px',
  backgroundColor: isActive ? primaryBlue : '#f3f4f6',
  color: isActive ? 'white' : '#6b7280',
  border: isActive ? `2px solid ${primaryBlue}` : '2px solid transparent',
  borderRadius: '8px',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: '600',
  transition: 'all 0.2s'
});

// ── Hover handlers ────────────────────────────────────────────────────────────

export const blueHover = (e) => { e.target.style.backgroundColor = hoverBlue; };
export const blueOut   = (e) => { e.target.style.backgroundColor = primaryBlue; };
